"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SLMRelationshipStatus;
(function (SLMRelationshipStatus) {
    SLMRelationshipStatus[SLMRelationshipStatus["INIT"] = 0] = "INIT";
    SLMRelationshipStatus[SLMRelationshipStatus["RECEIVED_COUPON"] = 1] = "RECEIVED_COUPON";
    SLMRelationshipStatus[SLMRelationshipStatus["LIFTED"] = 2] = "LIFTED";
    SLMRelationshipStatus[SLMRelationshipStatus["FUNDED"] = 3] = "FUNDED";
    SLMRelationshipStatus[SLMRelationshipStatus["REFUNDED"] = 4] = "REFUNDED";
})(SLMRelationshipStatus = exports.SLMRelationshipStatus || (exports.SLMRelationshipStatus = {}));
var UserSLMStatus;
(function (UserSLMStatus) {
    UserSLMStatus[UserSLMStatus["INACTIVE"] = 0] = "INACTIVE";
    UserSLMStatus[UserSLMStatus["ACTIVE"] = 1] = "ACTIVE";
    UserSLMStatus[UserSLMStatus["NOT_ELIGIBLE"] = 2] = "NOT_ELIGIBLE";
})(UserSLMStatus = exports.UserSLMStatus || (exports.UserSLMStatus = {}));
var SLMCustomKey;
(function (SLMCustomKey) {
    SLMCustomKey[SLMCustomKey["UNKNOWN"] = 0] = "UNKNOWN";
    SLMCustomKey[SLMCustomKey["COUPON_AMOUNT"] = 1] = "COUPON_AMOUNT";
})(SLMCustomKey = exports.SLMCustomKey || (exports.SLMCustomKey = {}));
var RewardType;
(function (RewardType) {
    RewardType[RewardType["NONE"] = 0] = "NONE";
    RewardType[RewardType["POINT"] = 1] = "POINT";
    RewardType[RewardType["CASH"] = 2] = "CASH";
    RewardType[RewardType["ADVANCED_COURSE"] = 3] = "ADVANCED_COURSE";
    RewardType[RewardType["TEACHING_AID"] = 4] = "TEACHING_AID";
    RewardType[RewardType["COUPON"] = 5] = "COUPON";
    RewardType[RewardType["ACHIEVEMENT"] = 6] = "ACHIEVEMENT";
    RewardType[RewardType["PAINTING_SUIT_GIFT_BOX"] = 7] = "PAINTING_SUIT_GIFT_BOX";
    RewardType[RewardType["BUILING_BLOCKS_GIFT_BOX"] = 8] = "BUILING_BLOCKS_GIFT_BOX";
    RewardType[RewardType["GAME_CHESS_SUIT"] = 9] = "GAME_CHESS_SUIT";
})(RewardType = exports.RewardType || (exports.RewardType = {}));
//# sourceMappingURL=slm.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/slm.js
// module id = 1010
// module chunks = 0